const doc = [({"ja":({"adminHotelMail":({"saveSetting":"メール設定を保存する", "saveInformation":"{{type}}の注意事項を保存する"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;